var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.053,
    height: 15.7,
    viewBox: "0 0 21.053 15.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.151,19.969.308,13.126a1.053,1.053,0,0,1,0-1.489L1.8,10.149a1.053,1.053,0,0,1,1.489,0l4.609,4.609,9.873-9.873a1.053,1.053,0,0,1,1.489,0l1.489,1.489a1.053,1.053,0,0,1,0,1.489L8.639,19.969A1.053,1.053,0,0,1,7.151,19.969Z",
    transform: "translate(0 -4.577)",
    fill: "#8396a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionCheckmark);
export default __webpack_public_path__ + "static/media/introduction_checkmark.ad6fb43774ab47c677325e6804683067.svg";
export { ForwardRef as ReactComponent };